export default __webpack_public_path__ + "static/media/rd_station.e1ca93e6.svg";